<template>
  <div class="d-flex pa-2 full-width" v-on="$listeners">
    <v-avatar color="#F4F7FA" size="80" v-if="!isMobile" class="mt-1">
      <v-icon color="#073430" size="50" v-if="typeDatastore == 'shapefile'"
        >mdi-shape-plus</v-icon
      >
      <v-icon v-else color="#073430" size="50">mdi-link</v-icon>
    </v-avatar>
    <div
      class="px-4 justify-center flex-grow-1 d-flex flex-column overflow-hidden"
    >
      <div class="full-width">
        <div class="align-center d-flex">
          <div class="flex-grow-1 mr-2" :title="item.name">
            <div class="text-title mb-2 mt-2"> {{ item.name }}</div>
            <div>
              <v-chip
                small
                class="ma-1"
                :color="typeDatastore == 'api' ? 'indigo' : 'orange'"
                label
                outlined
              >
                {{ typeDatastore.toUpperCase() }}
              </v-chip>
            </div>
          </div>
          <div class="flex-grow-0 d-flex flex-column align-end">
            <div class="flex-grow-0 d-flex">
              <v-btn
                icon
                @click.stop="onDownloadItem(item)"
                v-if="['shapefile', 'tif', 'pdf'].includes(item.type)"
              >
                <v-icon>mdi-cloud-download-outline</v-icon>
              </v-btn>
              <v-btn
                icon
                @click.stop="onUpdateItem(item)"
                v-if="checkAccess('workspace.setting')"
              >
                <v-icon>mdi-cog</v-icon>
              </v-btn>
              <v-btn
                icon
                color="error"
                @click.stop="onDeleteItem(item)"
                v-if="checkAccess('workspace.delete', item)"
              >
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </div>
            <div>
              {{ item.time_data | dateTime }}
            </div>
          </div>
        </div>
      </div>
      <div class="">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { sdk } from '@service/http/axios'
import { saveAs } from 'file-saver'
import { v4 as uuidv4 } from 'uuid'

export default {
  props: {
    value: { type: Object, require: true, default: () => ({}) },
  },
  data: () => ({}),
  computed: {
    item() {
      return this.value
    },
    typeDatastore() {
      if (
        this.value.details &&
        this.value.details.length > 0 &&
        this.value.details[0].type == 'api'
      ) {
        return 'api'
      }
      if (this.value.type === 'tif') {
        return 'TIF'
      }
      if (this.value.type === 'pdf') {
        return 'GEOPDF'
      }
      return 'shapefile'
    },
  },
  methods: {
    onUpdateItem(item) {
      this.$emit('update-item', item)
    },
    onDeleteItem(item) {
      this.$emit('delete-item', item)
    },
    async onDownloadItem(item) {
      const res = await sdk.request({
        url: `datastores/${item.id}/download/${uuidv4()}`,
        method: 'GET',
        responseType: 'blob',
      })
      if (res && res.status == 200) {
        saveAs(new Blob([res.data]), `${item.id}.zip`)
      }
    },
  },
}
</script>

<style scoped>
.text-title {
  font-style: 17px;
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #001e2b;
}
</style>
